const ACTION_LABELS = {
  block: 'Блокировка пользователя',
  unblock: 'Разблокировка пользователя',
  archive: 'Архивация',
  hide_content: 'Скрытие содержимого комментария',
  destroy_user: 'Удаление пользователя',
  destroy_track: 'Удаление трека',
  destroy_trip: 'Удаление поездки',
  destroy_comment: 'Удаление комментария',
  destroy_all_comments: 'Удаление всех комментариев',
  destroy_all_comments_and_block: 'Удаление комментариев и блокировка',
}

const ROLE_LABELS = {
  participant: 'Участник',
  moderator: 'Модератор',
  admin: 'Администратор',
}

const COMMENT_TYPE_LABELS = {
  track: 'Трек',
  trip: 'Поездка',
  event: 'Событие',
}

const TARGET_TYPE_LABELS = {
  User: 'Пользователь',
  Track: 'Трек',
  Trip: 'Поездка',
  TrackComment: 'Комментарий к треку',
  TripComment: 'Комментарий к поездке',
  EventComment: 'Комментарий к событию',
}

const METADATA_LABELS = {
  comment_type: 'Тип',
  user_id: 'Автор',
  body: 'Текст комментария',
  body_preview: 'Текст комментария',
  email: 'Email',
  display_name: 'Имя',
}

export function moderationActionLabel(action) {
  return ACTION_LABELS[action] ?? action
}

export function userRoleLabel(role) {
  return ROLE_LABELS[role] ?? role
}

export function commentTypeLabel(type) {
  return COMMENT_TYPE_LABELS[type] ?? type
}

export function targetTypeLabel(type) {
  return TARGET_TYPE_LABELS[type] ?? type
}

export function metadataLabel(key) {
  return METADATA_LABELS[key] ?? key
}

export const MODERATION_ACTION_KINDS = Object.keys(ACTION_LABELS)

export const MODERATION_TARGET_TYPES = Object.keys(TARGET_TYPE_LABELS)
